import gql from "graphql-tag";
import * as React from "react";

import type {MutateFn} from "@repo/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import ApolloMutation from "#data-access/gql/apollo-mutation.tsx";

const MUTATION: GqlOperation<Data> = gqlOp(gql`
    mutation resendUnderAgeGateApprovalEmailForLogin {
        resendUnderAgeGateApprovalEmail {
            error {
                code
            }
        }
    }
`);

type Data = {
    error:
        | {
              code: "INTERNAL" | "NOT_FOUND" | "UNAUTHORIZED";
          }
        | null
        | undefined;
};

type Props = {
    children: (arg1: {
        resendUnderAgeGateApprovalEmail: MutateFn<Data>;
        isLoading: boolean;
    }) => React.ReactNode;
    onCompleted: (data?: Data | null | undefined) => void;
    onError: (arg1: Error) => void;
};

export type ResendUnderAgeGateApprovalEmailResponse = Data;

export default class ResendUnderAgeGateApprovalEmailMutation extends React.Component<Props> {
    render(): React.ReactNode {
        const {children, onCompleted, onError} = this.props;

        return (
            <ApolloMutation
                mutation={MUTATION}
                onCompleted={onCompleted}
                onError={onError}
            >
                {(resendUnderAgeGateApprovalEmail, {loading}) =>
                    children({
                        resendUnderAgeGateApprovalEmail,
                        isLoading: loading,
                    })
                }
            </ApolloMutation>
        );
    }
}
